import {Injectable} from '@angular/core';
import {HttpOptionsModel} from '@myModels/Shared/http-options';
import {CustomHttpService} from '@myServices/custom-http.service';
import {catchError, map} from 'rxjs/operators';
import {AuthenticationService} from '@myServices/authentication.service';

@Injectable()
export class TransactionService {

    constructor(private customHttpService: CustomHttpService, private authService: AuthenticationService) {
    }

    public qrDeposit(qrCode: string) {

        const httpOptionsModel = new HttpOptionsModel(
            '/qr-deposit',
            {qr: qrCode},
            true,
            true
        );

        return this.customHttpService.post2(httpOptionsModel).pipe(catchError((error) => {
            if (error.error.messages) {
                if ('TICKET_NOT_FOUND' === error.error.messages[0]) {
                    throw new Error('TRANSACTION.INVALID_QR_CODE');
                }
                throw new Error(error.error.messages[0]);
            }
            throw new Error('UNEXPECTED_ERROR');
        }), map(resp => {
            if (!resp.status) {
                if (resp.messages.length > 0) {
                    throw new Error(resp.messages[0]);
                } else {
                    throw new Error('MESSAGES.UNEXPECTED_ERROR');
                }
            }
            this.authService.user.balance = resp.data.user.balance;
            return resp.data;
        }));
    }
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Modules/Shared/services/transaction.service.ts